import { User } from '../models/user';

export interface IUpdateUserStatusBulkSuccessPayload {
    users: User[];
    asyncJobId?: string;
}

export class UpdateUserStatusBulkSuccess {
    static readonly type = '[User] UpdateUserStatusBulkSuccess';

    constructor(public payload: IUpdateUserStatusBulkSuccessPayload) {}
}
